module.exports = __webpack_public_path__ + "static/img/introduction-low.f9f2bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-low.jpg
// module id = qm2U
// module chunks = 0